import api from "../helpers/axios";

class AssistantService {

    async getAssistantList(queryParams = "") {
        try {
            const url = `/assistants/?platform=admin${queryParams}`;
            const assistants = await api.get(url);
            return assistants.data;
        } catch (error) {
            console.log("Error getAssistantList: ", error);
        }
    }

    async createAssistant(payload) {
        try {
            const url = `/assistants/`;
            const assistant = await api.post(url, payload);
            return assistant.data;
        } catch (error) {
            console.log("Error createAssistant: ", error);
        }
    }

    async updateAssistant(assistantId, payload) {
        try {
            const url = `/assistants/${assistantId}`;
            const assistant = await api.patch(url, payload);
            return assistant.data;
        } catch (error) {
            console.log("Error updateAssistant: ", error);
        }
    }

    async deleteAssistant(assistantId) {
        try {
            const url = `/assistants/${assistantId}`;
            await api.delete(url);
            return true;
        } catch (error) {
            console.log("Error deleteAssistant: ", error);
            return false;
        }
    }

    async getAssistantDetails(assistant_id) {
        try {
            const url = `/assistants/${assistant_id}`;
            const assistants = await api.get(url);
            return assistants.data;
        } catch (error) {
            console.log("Error getAssistantDetails: ", error);
            throw error;
        }
    }

    async getAssistantFacilityAccessList(assistant_id) {
        try {
            const url = `/assistants/facility_access_list/${assistant_id}`;
            const assistants = await api.get(url);
            return assistants.data;
        } catch (error) {
            console.log("Error getAssistantFacilityAccessList: ", error);
            throw error;
        }
    }

    async updateAssistantFacilityAccessList(assistantId, payload) {
        try {
            const url = `/assistants/facility_access/${assistantId}`;
            const assistant = await api.put(url, payload);
            return assistant.data;
        } catch (error) {
            console.log("Error updateAssistantFacilityAccessList: ", error);
        }
    }

    async getAssistantUserAccessList(assistant_id) {
        try {
            const url = `/assistants/user_access_list/${assistant_id}`;
            const response = await api.get(url);
            return response.data;
        } catch (error) {
            console.log("Error getAssistantUserAccessList: ", error);
            throw error;
        }
    }

    async updateAssistantUserAccessList(assistantId, payload) {
        try {
            const url = `/assistants/user_access/${assistantId}`;
            const response = await api.put(url, payload);
            return response.data;
        } catch (error) {
            console.log("Error updateAssistantUserAccessList: ", error);
            throw error;
        }
    }

    async getAssistantFileList(assistant_id) {
        try {
            const url = `/assistants/file_list/${assistant_id}`;
            const assistantsFiles = await api.get(url);
            return assistantsFiles.data;
        } catch (error) {
            console.log("Error getAssistantFileList: ", error);
            throw error;
        }
    }

}

export default new AssistantService();

